function hashString(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash.toString(36).padStart(8, '0');
}

function getUniqueId(): string {
  const userAgent = navigator.userAgent;
  const screenResolution = `${screen.width}x${screen.height}`;
  const colorDepth = screen.colorDepth;
  const timezoneOffset = new Date().getTimezoneOffset();

  const rawId = `${userAgent}-${screenResolution}-${colorDepth}-${timezoneOffset}`;

  let uniqueId = hashString(rawId);

  while (uniqueId.length < 32) {
    uniqueId += hashString(uniqueId);
  }

  return uniqueId.substring(0, 32);
}

export default getUniqueId;
